import axios from "axios";
import cookie from "react-cookies";
import { store, persistor } from "store/index";
import { setToken, setLoader, setSub, setPasswordPopup , setAlert } from "action/index.js";
import { toast } from "react-toastify";
import { getStoredUtmParams } from "util/utmTracker";

// let base = process.env.REACT_APP_API_URL;
// let base = "https://la-stagingbe.languageacademy.com.au"
let base = `${import.meta.env.VITE_API_URL}`;
let base_new = `${import.meta.env.VITE_URL_ALT}`;

// const base = `https://ladevtesting.languageacademy.com.au`;
// const s3base = `https://testing.languageacademy.com.au`;
// const s3base = `http://127.0.0.1:8000`;
const s3base = "https://s3.ap-southeast-2.amazonaws.com/lamedia21";
const axiosInstance = axios.create({
  baseURL: `${base}/api/v2`,
  // withCredentials: true
});

let auth401AlertShown = false;

// axiosInstance.defaults.headers.common["Cache-Control"] = "no-store";
axiosInstance.defaults.headers.common["Cache-Control"] = "no-cache, no-store, must-revalidate";
axiosInstance.defaults.headers.common["Pragma"] = "no-cache";
axiosInstance.defaults.headers.common["Expires"] = "0";

axiosInstance.interceptors.response.use(
  (response) => successHandler(response),
  (error) => errorHandler(error)
);

function select(state) {
  return state.token;
}
function listener() {
  let token = select(store.getState());
  axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  if (token) {
    auth401AlertShown = false;
  }
}

const errorHandler = (error) => {
  if (error.config.url !== "https://la-ping.languageacademy.com.au/connected") {
    const status = error.response?.status; // optional chaining
    const dataStatus = error.response?.data?.status;

    if (status === 503 && dataStatus === "server is down for maintenance") {
      window.location.href = "/maintenance";
    }

    if (isHandlerEnabled(error.config)) {
      // Handle errors
    }

    store.dispatch(setLoader(true));

    if (status === 401) {
      const { code } = error.response.data || {};
      if (code === "blocked-region-access") {
        return (window.location.href = "/invalid/region");
      } else {
        store.dispatch(setToken(null));
        store.dispatch(setPasswordPopup(false));
        if (!auth401AlertShown) {
          store.dispatch(
            setAlert({
              flag: true,
              type: 2,
              message:
                "You have been logged out. Please sign in again to continue.",
            })
          );
          auth401AlertShown = true;
        }
      }
    }

    if (status === 402) {
      store.dispatch(setSub(false));
    }

    // Handle network errors
    if (!error.response) {
      console.error("Network or timeout error:", error.message);
      toast.error("Network error. Please check your internet connection.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  }
  return Promise.reject(error);
};

const isHandlerEnabled = (config = {}) => {
  return config.hasOwnProperty("handlerEnabled") && !config.handlerEnabled
    ? false
    : true;
};

// const requestHandler = (request) => {
//   if (
//     request.url !== "check/payment" &&
//     request.url !== "delete/question/responseNew" &&
//     !/^submit\/practice\?random=\d{1,9}$/.test(request.url) &&
//     request.url !== "show/history" &&
//     request.url !== "show/comment" &&
//     request.url !== "show/notes" &&
//     request.url !== "submit/mock" &&
//     request.url !== "set/mockTime" &&
//     // && request.url !== 'set/tag'
//     request.url !== "dashboard/data2" &&
//     request.url !== "https://la-ping.languageacademy.com.au/connected" &&
//     request.url !== "submitFailed/mock" &&
//     request.url !== "translate/sentence" &&
//     request.url !== "generate/aiaudio" &&
//     request.url !== "word/definition" &&
//     request.url !== "submit-explanation" &&
//     request.url !== "mark/viewed"
//   ) {
//     store.dispatch(setLoader(false));
//   }

//   return request;
// };

const requestHandler = (request) => {
  // Skip region access check for full URLs (external APIs)
  if (request.url && request.url.startsWith("http")) {
    // Only handle loader for external URLs
    if (request.url !== "https://la-ping.languageacademy.com.au/connected") {
      store.dispatch(setLoader(false));
    }
    return request;
  }
  // Region access check
  const state = store.getState();
  const { token, regionAccess } = state;

  if (token && !regionAccess) {
    const allowedEndpoints = [
      "logout",
      "getPackages",
      "getCcavPackages",
      "subscribe",
      "getNotifications",
      "/sub/payment/form/32",
      "/sub/success",
      "voidInvoice",
      "https://ipbackend22.languageacademy.com.au/api/v2/getPackages?countryId=",
    ];
    const authEndpoints = ["login", "register", "forgot", "reset"];
    const planEndpoints = ["plan", "payment", "sub", "ccav"];

    // Check if URL matches any allowed endpoint (including query params)
    const isAllowedEndpoint = allowedEndpoints.some(
      (endpoint) =>
        request.url === endpoint || request.url.startsWith(endpoint + "?")
    );

    const isAuthEndpoint = authEndpoints.some((endpoint) =>
      request.url.includes(endpoint)
    );

    const isPlanEndpoint = planEndpoints.some((endpoint) =>
      request.url.includes(endpoint)
    );

    const isAllowed = isAllowedEndpoint || isAuthEndpoint || isPlanEndpoint;

    if (!isAllowed) {
      return Promise.reject({
        response: {
          status: 403,
          data: { message: "Region access restricted" },
        },
      });
    }
  }

  if (
    request.url !== "check/payment" &&
    request.url !== "delete/question/responseNew" &&
    !/^submit\/practice\?random=\d{1,9}$/.test(request.url) &&
    request.url !== "show/history" &&
    request.url !== "show/comment" &&
    request.url !== "show/notes" &&
    request.url !== "submit/mock" &&
    request.url !== "set/mockTime" &&
    request.url !== "set/tag" &&
    request.url !== "dashboard/data2" &&
    request.url !== "https://la-ping.languageacademy.com.au/connected" &&
    request.url !== "submitFailed/mock" &&
    request.url !== "translate/sentence" &&
    request.url !== "generate/aiaudio" &&
    request.url !== "word/definition" &&
    request.url !== "submit-explanation" &&
    request.url !== "get-explanation"
  ) {
    store.dispatch(setLoader(false));
  }

  return request;
};

axiosInstance.interceptors.request.use((request) => requestHandler(request));

const LEAD_ENDPOINTS = new Set([
  "submit-query",
  "sendOnlinePte",
  "post/contact",
  "btc-submit-data"
]);

const utmHandler = (request) => {
  const method = (request.method || "").toLowerCase();
  if (method !== "post") return request;
console.log('urlsssssss',request.url);
  const normalizedUrl = (request.url || "").replace(/^\/+/, "");
  if (!LEAD_ENDPOINTS.has(normalizedUrl)) return request;

  const utm = getStoredUtmParams();
  if (!utm) return request;

  if (request.data instanceof FormData) {
    Object.entries(utm).forEach(([key, value]) => {
      if (!request.data.has(key)) request.data.append(key, value);
    });
  } else if (request.data && typeof request.data === "object") {
    request.data = { ...utm, ...request.data };
  }

  return request;
};

axiosInstance.interceptors.request.use((request) => utmHandler(request));

const successHandler = (response) => {
  if (isHandlerEnabled(response.config)) {
    // Handle responses
  }
  store.dispatch(setLoader(true));
  // console.log(store.getState().token);
  return response;
};

// Subscribe to store after axiosInstance is fully initialized
store.subscribe(listener);

export default axiosInstance;
export { base_new, base, s3base };
